import { render } from "./CashRefund.vue?vue&type=template&id=74a064dc"
import script from "./CashRefund.vue?vue&type=script&lang=js"
export * from "./CashRefund.vue?vue&type=script&lang=js"
script.render = render

export default script